import React from 'react';

import {IExternalLinkRenderer} from "./external-link-renderer.interface";
import {ExternalLinkIframeComponent} from "../../../components/external-links/external-link-iframe.component";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IModalDialogHandler} from "../../dialog/dialog.service.interface";
import {observable, runInAction} from "mobx";

interface ExternalLinkIframeRendererOptions {
    width: number;
    height: number;
    zIndex: number;
    onClosed: () => Promise<void>;

}

export class ExternalLinkIframeRenderer implements IExternalLinkRenderer {
    constructor(private readonly services: IServiceFactoryExtended,
                private readonly _options: ExternalLinkIframeRendererOptions) {
    }
    dispose(): void {
        this._dialogHandler?.close();
    }

    private _dialogHandler: IModalDialogHandler | null = null;
    @observable.ref
    iframeElementRef: HTMLIFrameElement | null = null;

    render(url: string): Promise<void> {
        return new Promise<void>((resolve) => {
            this.services.dialog.showModal((dialogHandler) => {
                this._dialogHandler = dialogHandler;
                return (
                    <ExternalLinkIframeComponent url={url}
                                                 width={this._options.width}
                                                 height={this._options.height}
                                                 onIframeCreated={element => {
                                                     runInAction(() => {
                                                         this.iframeElementRef = element;
                                                     });
                                                 }}
                                                 dialogHandler={dialogHandler}/>
                )
            }, {
                disableFullscreenMobile: false,
                hideCloseButton: true,
                noDefaultContentPadding: true,
                isHighPriority: true,
                forceZOrder: this._options.zIndex,
                onClosed: () => {
                    this._options.onClosed().then(() => resolve());
                }
            });
        });
    }

}